import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from "rxjs";
import { environment } from '../../environments/environment';
import { RecordOfAchievement } from "../gamification/models/record-of-achievement.model";
import { GameAnswers } from '../daily-game/models/game-answers.model';

@Injectable({
  providedIn: 'root',
})

export class GamificationService {
   constructor(private http: HttpClient) { }
 
  getAchievements$(): Observable<RecordOfAchievement> {
    return this.http.get<RecordOfAchievement>(`${environment.ppxPrivateApi}api/gamification`).pipe(
      catchError(err => throwError(err))
    );
  }

  getPoints$(): Observable<number> {
    return this.http.get<number>(`${environment.ppxPrivateApi}api/gamification/xp`).pipe(
      catchError(err => throwError(err))
    );
  }

  getGameForToday$(): Observable<GameAnswers> {
    return this.http.get<GameAnswers>(`${environment.ppxPrivateApi}api/gamification/play`).pipe(
      catchError(err => throwError(err))
    );
  }

  submitScore$(answers: GameAnswers): Observable<number> {
    return this.http.post<number>(`${environment.ppxPrivateApi}api/gamification/score`, answers).pipe(
      catchError(err => throwError(err))
    );
  }
}